<template>
  <ul
      :class="{'hide-mobile': !showCurrentMobile, 'show-mobile': showCurrentMobile, 'menu-item-visible': showCurrent, 'menu-item-hidden': !showCurrent}">
    <li class="menu-item" :class="{'items-mobile-opened': itemsOpenMobile}">
      <div class="custom-control custom-checkbox menu-label" :class="{'partial-checked': partialChecked}"
           @click="toggleChecked">
        <input type="checkbox" class="custom-control-input" v-model="checked" value="1" checked>
        <span class="custom-control-label" style="cursor: pointer" :class="{'text-grey': this.parent.type === 'user'}">
              {{ label }}
          </span>
      </div>

      <span @click="toggle" v-if="parent.items" class="tree-icon">
                <i v-if="opened"><img src="/images/black-minus.svg"></i>
                <i v-if="!opened"><img src="/images/black-plus.svg"></i>
      </span>
      <span @click="showMobile" v-if="parent.items" class="arrow-icon"><img src="/images/arrow_down.svg"></span>
    </li>
    <li v-if="parent.items" v-show="opened && showCurrent" style="padding-left: 32px">
      <structure-tree v-show="opened" class="menu-list" v-if="checkedItems.items[item.id]"
                      v-for="(item, key) in parent.items"
                      :key="item.id"
                      :label="item.name"
                      :parent="item"
                      :parentChecked="checked"
                      :presetValues="presetValues"
                      :checkedItems="checkedItems.items[item.id]"
                      :parentShowMobile="checkedItems.items[item.id].showMobile"
                      :parentLevel="parentLevel + 1"
                      :open="false"
                      :search="search"
                      @toggleMobile="toggleMobile"
                      @updateItemsSearch="updateItemsSearch"
                      @updateItemsChecked="updateItemsChecked">
      </structure-tree>
    </li>
  </ul>
</template>

<script>
import StructureTree from "./StructureTree";

export default {
  name: 'structure-tree',

  props: {
    parent: Object,
    checkedItems: Object,
    presetValues: Object,
    open: Boolean,
    parentChecked: Boolean,
    parentShowMobile: Boolean,
    label: String,
    search: String,
    parentLevel: Number
  },

  components: {
    StructureTree
  },

  data: () => ({
    opened: false,
    defaultOpened: false,
    checked: false,
    showCurrent: true,
    partialChecked: false,
    showCurrentMobile: true,
    itemsOpenMobile: false,
  }),

  created() {
    this.opened = this.open;
    this.defaultOpened = this.open;

    if (this.checkedItems.checked) {
      this.checked = true;
    }

    this.initElementsStatus();
  },

  watch: {
    parentChecked(value) {
      this.checked = value;
      if (!value) {
        this.partialChecked = false;
      }
    },

    async search(value) {
      await this.toggle();
      if (!this.search) {
        this.checkedItems.inSearch = false;
        this.checkedItems.itemsSearch = false;
        this.showCurrent = true;
        this.opened = this.defaultOpened;
        return;
      }

      this.checkedItems.inSearch = this.parent.name.toLowerCase().includes(value.toLowerCase());
      this.showCurrent = this.checkedItems.inSearch;

      this.$emit('updateItemsSearch')
    },

    checked(value) {
      if (value === this.checkedItems.checked) return;

      this.checkedItems.checked = value;
      this.checkedItems.changed = true;
      this.partialChecked = false;

      this.$emit('updateItemsChecked');
    },

    parentShowMobile(value) {
      this.showCurrentMobile = value;
    },

    partialChecked(value) {
      const oldPartialChecked = this.checkedItems.partialChecked;
      this.checkedItems.partialChecked = value;
      this.checkedItems.changed = true;

      if (this.checkedItems.partialChecked !== oldPartialChecked) {
        this.$emit('updateItemsChecked')
      }
    }
  },

  methods: {
    toggle() {
      if (this.parent.items && Object.keys(this.parent.items).length > 0) {
        this.opened = !this.opened;
        this.defaultOpened = !this.defaultOpened;
        return;
      }

      if (this.parent.type !== 'subdivision') {
        return;
      }

      axios.get('/' + window.IDP.role + '/structure?users=true&subdivision=' + this.parent.id).then(response => {
        if (response.data.users && Object.keys(response.data.users).length) {
          this.parent.items = response.data.users;
        }

        this.checkedItems.items = {};

        for (let [key, value] of Object.entries(this.parent.items)) {
          let checked = this.parentChecked;
          let changed = this.parentChecked;

          this.checkedItems.items[value.id] = {
            checked: checked, changed: changed, partialChecked: false,
            id: value.id + "", name: value.name, inSearch: false, itemsSearch: false,
            showMobile: false, itemsOpenMobile: false,
            type: value.type, items: {},
          }
        }

        if (this.parent.items && Object.keys(this.parent.items).length > 0) {
          this.opened = !this.opened;
          this.defaultOpened = !this.defaultOpened;
        }
      });
    },

    toggleChecked() {
      this.checked = !this.checked;
      this.partialChecked = false;
    },
    showMobile() {
      this.checkedItems.itemsOpenMobile = !this.checkedItems.itemsOpenMobile;
      this.itemsOpenMobile = this.checkedItems.itemsOpenMobile;
      this.toggle();

      this.$emit('toggleMobile', this.checkedItems.id, !this.opened);
    },
    toggleMobile(id, open) {
      _.each(this.checkedItems.items, (item) => {
        if(id !== item.id) {
          item.showMobile = open;
        }
      });
    },
    updateItemsSearch() {
      const searchItems = Object.values(this.checkedItems.items).filter(function (item) {
        return item.inSearch || item.itemsSearch;
      });

      const itemsSearched = searchItems.length > 0;
      const itemsPreviousSearched = this.checkedItems.itemsSearch;

      this.checkedItems.itemsSearch = itemsSearched;
      this.showCurrent = itemsSearched || this.checkedItems.inSearch;
      this.opened = itemsSearched;

      if (itemsSearched !== itemsPreviousSearched) {
        this.$emit('updateItemsSearch')
      }
    },

    updateItemsChecked() {
      const length = Object.keys(this.checkedItems.items).length;

      const checkedItems = Object.values(this.checkedItems.items).filter(function (item) {
        return item.checked;
      });

      const partialCheckedItems = Object.values(this.checkedItems.items).filter(function (item) {
        return item.partialChecked;
      });

      this.partialChecked = (checkedItems.length && checkedItems.length !== length) || partialCheckedItems.length;

      if (checkedItems.length && checkedItems.length === length) this.checked = true;
      if (!checkedItems.length && !partialCheckedItems.length) this.checked = false;
    },

    initElementsStatus() {
      if (!this.parent.items && Object.keys(this.parent.items).length === 0) {
        this.checkedItems.items = false;
        return;
      }

      let checked = this.parentChecked;
      let changed = this.parentChecked;

      if (this.parent.type === 'subdivision' && (!this.parent.items || Object.keys(this.parent.items).length === 0)) {
        let emptyItem = {
          checked: checked, partialChecked: false, type: 'user', changed: changed,
          name: '...', items: false, inSearch: false, itemsSearch: false
        };

        for (let i = 0; i < this.parent.users_count; i++) {
          let item = Object.assign({}, emptyItem);
          item.id = i;
          this.checkedItems.items[i] = item;
        }

        return;
      }

      for (let [key, value] of Object.entries(this.parent.items)) {
        let checked = this.parentChecked;
        let changed = true;

        let id = false;

        if (this.presetValues[value.type] && this.presetValues[value.type][value.id]) {
          checked = !!this.presetValues[value.type][value.id].status;
          changed = false;
          id = this.presetValues[value.type][value.id].id;
        }

        this.checkedItems.items[value.id] = {
          checked: checked, changed: changed, presetId: id, partialChecked: false,
          id: value.id, name: value.name, inSearch: false, itemsSearch: false,
          showMobile: true, itemsOpenMobile: false,
          type: value.type, items: {},
        }

        if (checked !== this.parentChecked) {
          this.$emit('updateItemsChecked')
        }
      }
    },
  }
}
</script>

<style scoped>
.menu-label {
  cursor: pointer;
  position: relative;
  display: inline-block;
  line-height: 30px;
  margin-top: 8px;
}

.menu-label label {
  cursor: pointer;
}

.menu-label .custom-control-label {
  padding-top: 4px;
}

@media (max-width: 576px) {
  .mass-assignments-modal-block .menu-label .custom-control-label {
    padding-top: 10px;
    margin-left: -5px;
  }
}

.menu-list {
  list-style: none;
}

.menu-label p {
  display: inline-block;
  margin-right: 5px;
}

.menu-label:hover .key-span {
  display: inline-block;
}

.tree-icon {
  width: 10px;
  height: 10px;
  margin-left: 8px;
  cursor: pointer;
}

.tree-icon img {
  width: 10px;
  height: 10px;
}

.arrow-icon {
  height: max-content;
  margin-left: 5px;
  padding: 11px;
}

.arrow-icon img {
  height: 15px;
}

@media (min-width: 576px) {
  .arrow-icon {
    display: none;
  }
}

.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.menu-item-visible {
  display: block;
}

.menu-item-hidden {
  display: none;
}
@media (min-width: 576px) {
  .menu-item {
    justify-content: start;
  }
}
</style>
